export default class PoisonBaitInfo {
    constructor(poisonBaitFound, number, comments, poisonbaitinfopages) {
        this.poisonBaitFound = poisonBaitFound;
        this.number = number;
        this.comments = comments;
        this.poisonbaitinfopages = poisonbaitinfopages;
    }
}